var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRequest)?_c('div',{staticClass:"my_loading"},[_c('i',{staticClass:"el-icon-loading",staticStyle:{"font-size":"50px"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }